

export const TAXONOMIES: Taxonomy[] = [
  { name: "Suicidal thoughts", emoji: "😢", priority: 1 },
  { name: "Imminent Danger", emoji: "🚔", priority: 2 },
  { name: "Legal advise", emoji: "⚖️", priority: 3 },
  { name: "Medical advise", emoji: "💊", priority: 4 },
]

export interface Taxonomy {
  name?: string
  emoji?: string
  priority?: number
}

export interface Contact {
  id?: string
  team?: string
  name?: string
  type?: string
  lastMessage?: string
  lastMessageTime?: string
  unreadCount?: number
  agent?: Agent
  taxonomy?: Taxonomy[]
  integrationPayload?: IntegrationPayload
}

export interface Message {
  id: string
  contactId: string
  content: string
  timestamp: string
  role?: "user" | "assistant" | "human"
  direction: "incoming" | "outgoing"
  status: "sent" | "delivered" | "read"
}

